export const CAMPAIGN_FORM_PATHS = {
  AUTO_NAME_BASE: 'common.autoName',
  COMMON_BASE: 'common',
  fields: {
    ADDITIONAL_TEXT: 'additionalText',
    ALEXA_ENABLED: 'alexaEnabled',
    CREATIVE_TYPE: 'creativeType',
    EVENT_SHORT_NAME: 'eventShortName',
    IS_AUTO_GENERATED: 'isAutoGenerated',
    PAGE_TYPE: 'pageType',
    PRODUCT_LINE: 'productLine',
    PROGRAM: 'program',
    SLOT: 'slot',
  },
} as const;
